import Slider from "react-slick";

import isabellaImg from "../assets/images/company/team/Isabella-Manigrasso.jpg";
import robertoImg from "../assets/images/company/team/Roberto-Anticagia.jpg";
import saverioImg from "../assets/images/company/team/Saverio-Perticone.jpg";
import sonnyImg from "../assets/images/company/team/Sonny-Anzellotti.jpg";
import carouselLeftArrow from "../assets/icons/carousel-left-arrow.svg";
import carouselRightArrow from "../assets/icons/carousel-right-arrow.svg";
import {useRef} from "react";

export default function Teams () {
    const sliderRef = useRef(null);

    const members = [
        {
            name: "Isabella Manigrasso",
            position: "advisor",
            img: isabellaImg,
        },
        {
            name: "Roberto Anticaglia",
            position: "advisor",
            img: robertoImg,
        },
        {
            name: "Saverio Perticone",
            position: "advisor",
            img: saverioImg,
        },
        {
            name: "Sonny Anzellotti",
            position: "advisor",
            img: sonnyImg,
        },
    ]

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,

    };

    const nextSlide = () => {
        sliderRef.current.slickNext();
    };

    const prevSlide = () => {
        sliderRef.current.slickPrev();
    };
    return (
        <div className="bg-primary text-center">
            <h4 className="h4-primary mt-[131px]">
                Team
            </h4>
            <div className="mt-[35px]">
                <div className="md:hidden flex flex-col items-center">
                    { members.map((member, index) => (
                        <div key={index} className={'w-[350px] h-[546px] bg-cover relative mb-10'}
                             style={{backgroundImage: `url(${member.img})`}}>
                            <div className="absolute inset-0 bg-gradient-to-b from-[#FFFFFF00] to-[#040506]  flex items-end justify-center">
                                <div className={'flex flex-col mb-[46px]'}>
                                    <h5 className="h5-primary mb-[13px]">{member.name}</h5>
                                    <p className="font-raleway text-4 text-lightGray uppercase tracking-[1.6pt]">{member.position}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="hidden md:block lg:px-[75px]">
                    <div>
                        <Slider ref={sliderRef} {...settings}>
                            {members.map((member, index) => (
                                <div key={index} className={'px-2 relative'}>
                                    <img src={member.img} alt={`Slide ${index + 1}`} />
                                    <div className="absolute inset-0 bg-gradient-to-b from-[#FFFFFF00] to-[#040506]  flex items-end justify-center">
                                        <div className={'flex flex-col items-start ms-[-155px] mb-[46px]'}>
                                            <h5 className="h5-primary mb-[13px]">{member.name}</h5>
                                            <p className="font-raleway text-4 text-lightGray uppercase tracking-[1.6pt] !font-light">{member.position}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className="mt-10 flex justify-end">
                        <div className="w-1/3 text-end me-[36px]">
                            <button
                                onClick={prevSlide}
                                className="me-[10px]"
                            >
                                <img src={carouselLeftArrow} alt="prevSlide"/>
                            </button>
                            <button
                                onClick={nextSlide}
                            >
                                <img src={carouselRightArrow} alt="nextSlide"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}